import { render, staticRenderFns } from "./AltinnTaxInvoicePreview.vue?vue&type=template&id=7c6e4c68&scoped=true&"
import script from "./AltinnTaxInvoicePreview.vue?vue&type=script&lang=ts&"
export * from "./AltinnTaxInvoicePreview.vue?vue&type=script&lang=ts&"
import style0 from "./AltinnTaxInvoicePreview.vue?vue&type=style&index=0&id=7c6e4c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6e4c68",
  null
  
)

export default component.exports